export class UnauthorizedError extends Error {}
export class ForbiddenError extends Error {}
export class APIError extends Error {}
export class AlreadySubmittedError extends Error {}